import { createAction } from 'redux-actions';

import { openFailedAlert } from 'actions/alert';
import { wrapFetchAuth } from 'actions/endpoint';

import { keyTransform } from 'util/helper';

import { updateApartmentByRoom } from './apartment';
import { updateRoomByApartment } from './room';
import { openMessageModal } from './modal';

export const collect = createAction(
	'COLLECT_APARTMENT_OR_ROOM',
	(type, id) => async (dispatch, getState) => {
		const { auth: { token: { accessToken } } } = getState();

		if (accessToken === '') {
			dispatch(openMessageModal('loginSignup', { type: 'loginForm' }));
			return { roomList: [], apartmentList: [] };
		}

		const { status, message } = await wrapFetchAuth('collect', {
			method: 'POST',
			body: JSON.stringify({ model: type, id }),
		});

		if (status !== 200) {
			throw openFailedAlert('generic', message);
		}

		const ID = parseInt(id, 10);
		const { collect: { roomList, apartmentList } } = getState();

		if (type === 'rooms') {
			console.log(roomList);
			return {
				roomList: roomList.includes(ID)
					? roomList.filter(tmpId => tmpId !== ID)
					: [...roomList, ID],
				apartmentList,
			};
		}

		return {
			apartmentList: apartmentList.includes(ID)
				? apartmentList.filter(tmpId => tmpId !== ID)
				: [...apartmentList, ID],
			roomList,
		};
	},
);

export const getCollect = createAction('FETCH_COLLECT', () => async dispatch => {
	const { status, message, data } = await wrapFetchAuth('user/collections', {
		method: 'GET',
	});

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const roomData = {};
	const roomList = data.rooms.map(item => {
		roomData[item.id] = keyTransform(item);
		const { apartment } = roomData[item.id];
		roomData[item.id].apartment = undefined;

		dispatch(updateApartmentByRoom(apartment, item.id));

		return item.id;
	});

	const apartmentData = {};
	const apartmentList = data.apartments.map(item => {
		apartmentData[item.id] = keyTransform(item);
		apartmentData[item.id].rooms.forEach(room => dispatch(updateRoomByApartment(room)));
		apartmentData[item.id].rooms = apartmentData[item.id].rooms.map(({ id }) => id);

		return item.id;
	});

	return {
		roomList,
		apartmentList,
		roomData,
		apartmentData,
	};
});



// WEBPACK FOOTER //
// ./src/actions/collect.js